module.exports = __webpack_public_path__ + "img/Natori1.3c428dc0.png";